import { Button, Card, Flex, Grid, Space, Typography } from "antd";

const { useBreakpoint } = Grid;
const { Text } = Typography;

export default function DeliverySettingsActionButton({ handleReset, setShowConfirmDialog }) {
  const screens = useBreakpoint();

  return (
    <Card
      variant="borderless"
      size="middle"
      style={{
        width: "100%",
        borderRadius: "0 0 15px 15px",
        border: 0,
        alignContent: "end",
        top: "5px"
      }}
    >
      <Flex
        justify={screens.md ? "space-between" : undefined}
        align={screens.md ? "end" : "center"}
        vertical={screens.md ? false : true}
        gap={screens.md ? undefined : "large"}
      >
        <Text type="secondary">Unsaved changes</Text>
        <Space size="middle">
          <Button
            size="large"
            color="danger"
            variant="text"
            onClick={handleReset}
          >
            DISCARD CHANGES
          </Button>
          <Button
            size="large"
            color="primary"
            variant="solid"
            onClick={() => setShowConfirmDialog(true)}
          >
            SAVE
          </Button>
        </Space>
      </Flex>
    </Card>
  );
};